module.exports = "/assets/af64a65b3cfd942d7ceffb6d1b8e121f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6H.png
// module id = 1085
// module chunks = 0